import { IApplicationState } from '../../types/redux';

export const selectOffersSuggestions = (state: IApplicationState) => state.offersSuggestions;
